module.exports = __webpack_public_path__ + "static/media/bre.b870e3a6.jpg";